import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import {
	IVideosAssignmentContext,
	VideosAssignmentContext,
} from '../../../../../videosAssignmentState/videosAssignmentContext';
import { Checkbox } from 'antd';
import style from './UnassignedCheckbox.module.scss';

const UnassignedCheckbox: React.FC = () => {
	const { toggleUnassignedVideos, isUnassignedVideos } =
		useContext<IVideosAssignmentContext>(VideosAssignmentContext);

	return (
		<Checkbox
			className={style.checkbox}
			onChange={toggleUnassignedVideos}
			checked={isUnassignedVideos}
			data-test="UnassignedCheckbox">
			<Text translationNameSpace="listing" translationKey="unassignedVideosLabel" asFragment={true} />
		</Checkbox>
	);
};

export default UnassignedCheckbox;
